export const useMode = () => {
    const mode = useState("mode", () => "normal");
    const setMode = (newMode) => {
        mode.value = newMode;
    };

    const headerMode = useState("headerMode", () => "light");
    const setHeaderMode = (newHeaderMode) => {
        headerMode.value = newHeaderMode;
    };

    const isSearchOpen = useState("isSearchOpen", () => false);
    const setIsSearchOpen = (newIsSearchOpen) => {
        isSearchOpen.value = newIsSearchOpen;
    };

    return {
        mode,
        setMode,
        headerMode,
        setHeaderMode,
        isSearchOpen,
        setIsSearchOpen,
    };
};
